import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { ChildSavingStepParams } from './types'
import { numberOfChildrenSchema } from './types'

export const numberOfChildren = (params: ChildSavingStepParams) => {
  const schema = numberOfChildrenSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_childSaving:steps.number_of_children.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_child_saving_de.shape.configuration_parameters.shape.number_of_children.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_childSaving:steps.number_of_children.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('number_of_children'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'amount_of_money',
    subFlow: SubFlow.ChildSaving,
  } as const satisfies AnyStepConfiguration
}
